import CanvasDragTarget, { DRAG_TARGET_TYPE, measureTransformedBounds } from './CanvasDragTarget';
import { measureLetterRectangle } from './TextElementDragTarget';

// The line of lyrics on the canvas. Drawn by the same kind of text element as a text line and outlined
// the same way, but there is only ever one of it, and which words it shows depends on the playback
// time rather than on a setting. Dragging it moves every line, since they all share one position.
export default class LyricsDragTarget extends CanvasDragTarget {

    constructor(lyricsRenderer, onCommit) {
        super('lyrics', DRAG_TARGET_TYPE.LYRICS);

        this.lyricsRenderer = lyricsRenderer;
        this.onCommit = onCommit;
    }

    // The letters of the line currently shown, without the glow and shadow padding. Null between lines:
    // the collector skips the lyrics then, but a target built while a line was showing can outlive it.
    getBounds() {
        const { elementContainer, text } = this.lyricsRenderer.textElement;

        if (!elementContainer.visible)
            return null;

        return measureTransformedBounds(text, measureLetterRectangle(text));
    }

    // The renderer's text element is configured from the lyrics style, so its position is the one the
    // Lyrics panel's Position sliders hold.
    getPosition() {
        return { ...this.lyricsRenderer.textElement.config.position };
    }

    // Anchored like a text line, so its box can sit up to its whole width away from the stored position.
    measureOffsetFromPosition(position) {
        const box = this.measureBox();

        if (!box)
            return { x: 0, y: 0 };

        return { x: box.centerX - position.x, y: box.centerY - position.y };
    }

    moveTo(position) {
        this.lyricsRenderer.moveTo(position);
    }

    commit(position) {
        this.onCommit({ position });
    }

    // The renderer holds on to the line under the pointer for the length of the drag; see
    // LyricsContainer.draw for why.
    startDrag() {
        this.lyricsRenderer.startDrag();
    }

    stopDrag() {
        this.lyricsRenderer.stopDrag();
    }
}
